<script>
    import { defaultCursorTrailItems } from "$lib/data/cursorTrailItems";

    export let items = defaultCursorTrailItems;
</script>

<div class="trail-wrap" aria-hidden="true">
    <div class="trail-list">
        {#each items as item (item.avif)}
            <div data-trail="item" class="trail-item">
                <picture>
                    <source srcset={item.avif} type="image/avif" />
                    <img
                        src={item.webp}
                        alt=""
                        class="trail-item__img"
                        loading="lazy"
                    />
                </picture>
            </div>
        {/each}
    </div>
</div>
